var map = {
	"./AmitPandey.jpeg": 19,
	"./Client_PropertyMaintenance/PM_LOGO_FINAL-01.png": 20,
	"./Client_PropertyMaintenance/PM_LOGO_FINAL-02.png": 21,
	"./Client_PropertyMaintenance/PM_LOGO_FINAL-03.png": 22,
	"./Client_PropertyMaintenance/PM_LOGO_FINAL-04.png": 23,
	"./Cuvoo.png": 24,
	"./Emil-Digitallabs.jpeg": 25,
	"./Flizone.png": 26,
	"./IndianInnovation.png": 27,
	"./Klapklap.png": 28,
	"./NewbeeLogo.png": 29,
	"./PM_LOGO_FINAL-03.png": 30,
	"./Ramesh_Flizone.jpg": 31,
	"./SumantKrSinha_Crest.jpeg": 32,
	"./ansal.png": 33,
	"./bookguru.png": 34,
	"./computrader.png": 35,
	"./crest.png": 36,
	"./digital-labs.png": 37,
	"./oculus_logo.png": 38,
	"./prop-maintenance.png": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;